const initialState = {
  content: {},
  sidebarContent: {},
  contentLoader: false,
  showApi: false
};

const ContentReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'CONTENT_LOADER':
      return {
        ...state,
        contentLoader: action.payload
      };
    case 'SET_CONTENT':
      return {
        ...state,
        content: action.payload,
        contentLoader: false
      };
    case 'SET_CONTENT_SIDEBAR':
      return {
        ...state,
        sidebarContent: action.payload,
        contentLoader: false
      };
    case 'SHOW_API':
      return {
        ...state,
        showApi: action.payload,
        contentLoader: false
      };
    default:
      return state;
  }
};

export default ContentReducer;
